// extracted by mini-css-extract-plugin
export default {"flex":"TableLabelBottom_flex__aLjtN"};